import type { Dispatch } from 'redux';
import { createActionFactory, Feature } from '../../../shared';

export const importContactsEmptyViewClickedAction = createActionFactory<void>(
    'ImportContactsEmptyViewClickedAction',
    Feature.ImportContacts
);

export const importContactsEmptyViewClicked = (dispatch: Dispatch) =>
    dispatch(importContactsEmptyViewClickedAction());
export type { Action } from '../../../shared';
